import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import FormGroup from "../FormGroup";
import sampleSizeMeans from "../../lib/sampleSizeMeans";

function useInput(defaultValue) {
  const [value, setValue] = useState(defaultValue);
  return {
    value,
    onChange: e => setValue(e.target.value)
  };
}

function Calculator({ onCalculate }) {
  const baselineValue = useInput();
  const baselineSTD = useInput();
  const relchange = useInput();
  const sampleSize = useInput();
  const baselineRollout = useInput(50);
  const reviewPeriod = useInput(7);

  function onSubmit(e) {
    e.preventDefault();
    const baselineRolloutPct = parseInt(baselineRollout.value, 10) / 100;
    const comparisonRolloutPct = 1 - baselineRolloutPct;

    const [minSample_total, minSample, minDays] = sampleSizeMeans(
      parseInt(sampleSize.value, 10),
      baselineRolloutPct,
      comparisonRolloutPct,
      parseFloat(relchange.value, 10) / 100,
      parseFloat(baselineValue.value, 10),
      parseFloat(baselineSTD.value, 10),
      parseInt(reviewPeriod.value, 10)
    );
    console.log(minSample_total, minSample, minDays);

    function getResultString() {
      if (minSample_total === minSample) {
        return (
          "To measure a " +
          Number(parseFloat(relchange.value, 10)) +
          "% difference to your metric, you will need at least " +
          Number(minSample_total) +
          " users, so we recommend running your experiment for " +
          Number(minDays) +
          " days."
        );
      } else {
        return (
          "To measure a " +
          Number(parseFloat(relchange.value, 10)) +
          "% difference to your metric, you will need at least " +
          Number(minSample) +
          " users. In order to meet the minimum sample size requirement of 355 users in each treatment, with your rollout plan you would need " +
          Number(minSample_total) +
          " users. We recommend running your experiment for " +
          Number(minDays) +
          " days."
        );
      }
    }
    const resultString = getResultString();

    // Dynamic Width (Build Regex) https://stackoverflow.com/questions/14484787/wrap-text-in-javascript
    const wrap = (s, w) =>
      s.replace(
        new RegExp(`(?![^\\n]{1,${w}}$)([^\\n]{1,${w}})\\s`, "g"),
        "$1\n"
      );

    console.log(resultString);
    onCalculate(wrap(resultString, 70));
  }

  return (
    <Form onSubmit={onSubmit}>
      <p />
      <FormGroup
        label="Baseline metric value"
        type="float"
        required
        {...baselineValue}
      />
      <FormGroup
        id="STD"
        label="Baseline standard deviation"
        type="float"
        min="0"
        required
        {...baselineSTD}
      />
      <FormGroup
        label="What size (relative %) change do you want to be able to detect (the MLDE)?"
        type="float"
        min="0"
        max="100"
        required
        {...relchange}
      >
        <>
          Equivalent to a comparison metric value of :{" "}
          {(baselineValue.value * (1 + relchange.value / 100)).toFixed(2)} or{" "}
          {(baselineValue.value * (1 - relchange.value / 100)).toFixed(2)}
        </>
      </FormGroup>
      <FormGroup
        label="What is your expected sample size per day?"
        type="number"
        min="1"
        required
        {...sampleSize}
      />
      <FormGroup
        label="What is your rollout % for the treatments?"
        type="range"
        min="0"
        max="100"
        step="1"
        required
        {...baselineRollout}
      >
        <>
          Baseline: {baselineRollout.value}% / Comparison:{" "}
          {100 - baselineRollout.value}%
        </>
      </FormGroup>
      <FormGroup
        label="How many days in your typical seasonality cycle? (if unsure, we recommend 7 days)"
        type="number"
        min="1"
        required
        {...reviewPeriod}
      />
      <br />
      <Button variant="primary" type="submit">
        Submit
      </Button>
    </Form>
  );
}

export default Calculator;
